import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cmsImagePrefix'
})
export class CmsImagePrefixPipe implements PipeTransform {

  transform(imageUrl: string): any {
    if (imageUrl?.startsWith('/uploads/')) {
      return `https://cms.clooper.com${imageUrl}`
      
    } else {
      return imageUrl
    }
  }

}
